import type {SVGProps} from 'react'

const SvgPlaceholderAvatar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={48}
    height={48}
    fill={'none'}
    viewBox={'0 0 96 96'}
    {...props}
  >
    <mask
      id={'placeholderAvatar_svg__a'}
      width={96}
      height={96}
      x={0}
      y={0}
      maskUnits={'userSpaceOnUse'}
      style={{
        maskType: 'alpha',
      }}
    >
      <circle
        cx={48}
        cy={48}
        r={48}
        fill={'#D9D9D9'}
      />
    </mask>
    <g
      fill={'#CED4D9'}
      mask={'url(#placeholderAvatar_svg__a)'}
    >
      <path d={'M48 23c-9.56 0-17.311 7.816-17.311 17.457 0 9.64 7.75 17.456 17.311 17.456s17.311-7.815 17.311-17.456S57.561 23 48 23M33.312 65.319C23.75 65.319 16 73.134 16 82.775V96h64V82.775c0-9.64-7.75-17.456-17.312-17.456z'} />
    </g>
  </svg>
)
export default SvgPlaceholderAvatar
